/* 劉備傳・第 10 章：漢水空營（建安二十四年，219）
 * 史實：《三國志·趙雲傳》注引《雲別傳》：黃忠去奪曹軍的糧，過時不回，趙雲帶數十騎出營接應，遇曹軍大隊，且鬥且退；
 *       「公軍追至圍，此時沔陽長張翼在雲圍內，翼欲閉門拒守，而雲入營，更大開門，偃旗息鼓。公軍疑雲有伏兵，引去。
 *       雲雷鼓震天，惟以戎弩於後射公軍，公軍驚駭，自相蹂踐，墮漢水中死者甚多。」劉備第二天來看，說「子龍一身都是膽也」。
 * 流程：1. 操作趙雲出營接應被圍的黃忠，一起退回營中。
 *       2. 空營：打開營門，站在營裡不動、不出手（部下也按兵不動）。曹軍到了營門前越來越疑；疑心滿了就引去。
 *          這時亂動、出手，曹軍就會殺進來。曹軍一退，雷鼓追射。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS, rout } from '../kit.ts';
import { CAMP, GATE, ZHONG, CAO } from '../maps/hanshui.ts';

const LV = 15;
const WEI = { spec: TROOPS.wei, name: '曹軍', hp: 500, maxHp: 500, atk: 28 };
const inCamp = (u) => Math.abs(u.x - CAMP.x) < CAMP.hw - 30 && Math.abs(u.y - CAMP.y) < CAMP.hh - 30;

export default {
  id: 'liubei-10', map: 'hanshui', hero: 'zhaoyun',
  title: '第 10 章　漢水空營', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '雲入營，更大開門，偃旗息鼓。公軍疑雲有伏兵，引去。', src: '《趙雲傳》注引《雲別傳》' }],
    text: '劉備與曹操爭漢中。黃忠去劫曹軍運糧，過了約定的時間還沒回來，趙雲帶數十騎出營接應。（這是正史裴注裡的「空營計」，比演義諸葛亮的空城計更有根據。）',
    goals: ['出營接應被圍的黃忠，退回營中', '大開營門，偃旗息鼓，讓曹軍起疑', '雷鼓追射'],
  },
  words: { ally: '蜀兵', foe: '曹軍' },
  stars: [
    { text: '黃忠平安回營', ok: (m) => m.vars.zhong && m.vars.zhong.alive },
    { text: '空營時一次也沒露餡', ok: (m) => !m.vars.broke },
    { text: '雷鼓追射：斬 5 人以上', ok: (m) => m.vars.chaseKills >= 5 },
  ],
  steps: [
    { // 1. 接應黃忠
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = GATE[0]; me.y = GATE[1] - 200;
        V.zhong = ally(w, 'huangzhong', ZHONG[0], ZHONG[1], LV); V.zhong.hold = ZHONG.slice(); V.zhong.hp = V.zhong.maxHp * 0.5;
        V.ring = Array.from({ length: 8 }, (_, i) => { const a = (i / 8) * Math.PI * 2; return m.foe('huangjin', ZHONG[0] + Math.cos(a) * 260, ZHONG[1] + Math.sin(a) * 180, WEI); });
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 150 + (i % 3) * 100, me.y + 80 + Math.floor(i / 3) * 70, '蜀騎'); u.spec = TROOPS.shu; m.join(u, me); return u; });
        m.line('趙雲', '漢升過了時辰還沒回來……隨我出營接應！');
        m.mark('zhong', ZHONG[0], ZHONG[1], '黃忠', false, V.zhong);
        m.obj('zhong', '接應被圍的黃忠，退回營中');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, z = V.zhong;
        if (!V.met && SG.gd(me.x, me.y, z.x, z.y) < 300) { V.met = true; z.hold = null; m.line('黃忠', '子龍！'); m.line('趙雲', '且戰且退，回營！'); m.unmark('zhong'); m.mark('camp', CAMP.x, CAMP.y, '營'); }
        return V.met && inCamp(me) && inCamp(z);
      },
    },
    { // 2. 更大開門，偃旗息鼓
      enter(m, w) {
        const V = m.vars;
        m.done('zhong'); m.unmark('camp');
        m.line('張翼', '曹軍大隊追來了！快關營門！');
        m.after(2.5, () => m.line('趙雲', '不。打開營門，收起旗子，不准擂鼓。'));
        m.after(5, () => m.line('提示', '站在營中不動、不出手；部下也按兵不動。曹軍到營門前會越來越疑。'));
        V.host = [];
        for (let k = 0; k < 3; k++) m.after(k * 4, () => { for (let i = 0; i < 8; i++) { const u = m.foe('huangjin', CAO[0] - 300 + (i % 4) * 100, CAO[1] + 200 + Math.floor(i / 4) * 100, WEI); u.home = [GATE[0] + (SG.rand() - 0.5) * 600, GATE[1] - 350 - SG.rand() * 300]; u.wary = true; V.host.push(u); } });
        V.doubt = 0; V.t2 = w.t;
        m.obj('doubt', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 營裡的人：按兵不動
        for (const u of m.alive(V.men).concat(V.zhong)) { if (u === V.zhong) { u.input.target = null; u.input.engage = false; u.input.moveTo = null; } else { u.owner = null; u.home = u.home && inCamp(u) ? u.home : [CAMP.x + (SG.rand() - 0.5) * 400, CAMP.y + 100]; u.target = null; u.think = 0.5; } }
        const near = V.host.filter((u) => u.alive && SG.gd(u.x, u.y, GATE[0], GATE[1]) < 900).length;
        const quiet = inCamp(me) && m.idle(me) && !me.act;
        if (near >= 6) {
          if (quiet && !V.charging) V.doubt = Math.min(100, V.doubt + dt * 6);
          else if (!quiet) V.doubt = Math.max(0, V.doubt - dt * 25);
        }
        // 露餡：疑心掉光時有人在動 → 曹軍殺進來
        if (!quiet && near >= 6 && V.doubt <= 0 && !V.charging) { V.charging = true; V.broke = true; m.line('曹軍', '營裡沒有伏兵！殺進去！'); for (const u of V.host) if (u.alive) { u.wary = false; u.home = [CAMP.x, CAMP.y]; } }
        for (const u of V.host) if (u.alive && u.wary) { u.target = null; u.think = 0.5; }
        m.get('doubt').text = `曹軍的疑心：${Math.round(V.doubt)}%（${near >= 6 ? '曹軍在營門前' : '曹軍還在路上'}）`;
        return V.doubt >= 100 || (V.charging && V.host.filter((u) => u.alive).length <= 4);
      },
    },
    { // 3. 雷鼓震天
      enter(m, w) {
        const V = m.vars;
        m.done('doubt');
        if (!V.charging) m.card('公軍疑雲有伏兵，引去。', '《雲別傳》（裴注）');
        m.after(1.5, () => m.line('趙雲', '擂鼓！弩手追射！'));
        for (const u of V.host) if (u.alive) { u.wary = false; u.home = [CAO[0], CAO[1]]; u.target = null; u.ms = 110; u.st.stun = 1.5; } // 驚駭，自相蹂踐：愣一下、逃得慢
        for (const u of m.alive(V.men)) m.join(u, w.player);
        V.dead0 = V.host.filter((u) => !u.alive).length; V.chaseKills = 0;
        m.obj('chase', '雷鼓追射');
        V.t3 = w.t;
      },
      tick(m, w) {
        const V = m.vars;
        V.chaseKills = V.host.filter((u) => !u.alive).length - V.dead0;
        m.get('chase').text = `雷鼓追射（斬 ${V.chaseKills}）`;
        return w.t - V.t3 > 22;
      },
    },
    { // 4. 子龍一身都是膽也
      enter(m, w) {
        m.done('chase');
        m.card('雲雷鼓震天，惟以戎弩於後射公軍，公軍驚駭，自相蹂踐，墮漢水中死者甚多。', '《雲別傳》（裴注）');
        m.after(5, () => m.line('劉備', '子龍一身都是膽也！'));
        rout(m, w, m.vars.host, CAO);
        m.after(9, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('趙雲陣亡'); return; }
    if (V.zhong && m.i === 0) allyTick(w, V.zhong, V.met ? w.player : null, 400);
    if (V.zhong && m.i >= 2) allyTick(w, V.zhong, w.player);
  },
};
